import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent } from '@shared/button/button.component';
import { ModalTemplateComponent } from '@shared/modals/modal-template/modal-template.component';
import { ModalTemplateNoHeaderParams } from '@shared/modals/modal-template-no-header/modal-template-no-header-params';


/**
 * Only modal body and footer.
 * Footer is a single button that spans the bottom of the modal.
 */
@Component({
  selector: 'zbp-modal-template-no-header',
  templateUrl: './modal-template-no-header.component.html',
  styleUrls: ['./modal-template-no-header.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    ButtonComponent,
    ReactiveFormsModule,
    ModalTemplateComponent,
  ]
})
export class ModalTemplateNoHeaderComponent {

  params: ModalTemplateNoHeaderParams;

  constructor(public activeModal: NgbActiveModal) {
  }

  static open(ngbModal: NgbModal, params: ModalTemplateNoHeaderParams): NgbModalRef {
    const modalRef = ngbModal.open(
      ModalTemplateNoHeaderComponent,
      {
        ...params?.options,
      }
    );
    const component = modalRef.componentInstance;
    component.params = params;
    return modalRef;
  }

  closeModal() {
    this.activeModal.close(true);
  }
}
